import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import { Field, FieldArray, reduxForm } from "redux-form";
import { renderEquipment } from "./FormPartials/EquipmentsPartial";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import BaseButton from "components/UI/Buttons/BaseButton";
import { TextField } from "redux-form-material-ui";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
// import ReactSelect from 'components/UI/Forms/ReactSelect/ReactSelectInput'

const styles = theme => ({
  root: {
    flexGrow: 1,
    fontWeight: 500,
  },
  button: {
    margin: theme.spacing.unit,
    height: 32,
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
});

const required = value => (value == null ? "Required" : undefined);

const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email"
    : undefined;

const phoneNumber = value =>
  value && !/([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/g.test(value)
    ? "Invalid phone number, must be 10 digits"
    : undefined;

class CustomersForm extends React.PureComponent {
  handleDiscard = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      handleSubmit,
      pristine,
      reset,
      submitting,
      isEditing,
      classes,
      formInitValues,
    } = this.props;

    const { regions } = formInitValues;

    const formTitlePrefix = !isEditing ? "Create" : "Edit";

    return (
      <div className={classes.root}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={24}>
            <Grid item xs={8}>
              <Typography component="h2" variant="h5" gutterBottom>
                {`${formTitlePrefix} Customer`}
              </Typography>
            </Grid>
            <Grid item xs={4} className={classes.alignRight}>
              <IconButton aria-label="Close" onClick={this.handleDiscard}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Field
                name="name"
                component={TextField}
                placeholder="Name"
                label="Customer Name"
                margin="none"
                variant="outlined"
                validate={required}
                InputLabelProps={{
                  shrink: true,
                }}
                required
                fullWidth
                autoFocus
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Field
                name="address"
                component={TextField}
                placeholder="Address"
                label="Address"
                margin="none"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Field
                name="city"
                component={TextField}
                placeholder="City"
                label="City"
                margin="none"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Field
                name="state"
                component={TextField}
                placeholder="State"
                label="State"
                margin="none"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Field
                name="email"
                component={TextField}
                placeholder="Email Id"
                label="Email"
                margin="none"
                variant="outlined"
                validate={[required, email]}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Field
                name="phone"
                component={TextField}
                type="tel"
                placeholder="Phone Number"
                label="Phone Number"
                margin="none"
                variant="outlined"
                validate={[required, phoneNumber]}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Field
                name="regionId"
                component={TextField}
                select
                placeholder="Region"
                validate={required}
                label="Region"
                variant="outlined"
                margin="none"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {regions ? (
                  regions.map(region => {
                    return (
                      region.id !== "*" && (
                        <MenuItem key={region.id} value={region.id}>
                          {region.name}
                        </MenuItem>
                      )
                    );
                  })
                ) : (
                  <MenuItem value="">No Data available</MenuItem>
                )}
              </Field>
            </Grid>

            <Grid item xs={12} sm={12}>
              <InputLabel htmlFor="equipments">Equipments</InputLabel>
              <FieldArray
                name="equipments"
                component={renderEquipment}
                formInitValues={formInitValues}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <Field
                name="notes"
                component={TextField}
                placeholder="Notes"
                label="Notes"
                margin="none"
                variant="outlined"
                fullWidth
                multiline
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <BaseButton
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={pristine || submitting}
              >
                {!isEditing ? "Create" : "Update"}
              </BaseButton>

              <BaseButton
                type="button"
                variant="outlined"
                className={classes.button}
                disabled={pristine || submitting}
                onClick={reset}
              >
                Clear
              </BaseButton>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

CustomersForm.defaultProps = {
  isEditing: false,
};

CustomersForm = withStyles(styles)(CustomersForm);

export default reduxForm({
  form: "CustomersForm",
})(CustomersForm);
